import React, {useEffect, useState} from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import {edit, listColorTypes, listSportsHall} from '../../../lib/api/club';

export function Edit({ initialData, onClose, onSave }) {
  const [club, setClub] = useState(initialData);
  const [sportsHall, setSportsHall] = useState([]);
  const [colorTypes, setColorTypes] = useState([]);
  const getColorValue = color => (color ? color.toLowerCase() : '');
  const getColorTypeById = colorTypeId =>
    colorTypes.find(p => String(p.color_types_id) === String(colorTypeId));
  const [errors, setErrors] = useState({
    name: false,
    short_name: false,
    place: false,
    federation_entities_id: false,
    sports_hall_id: false,
    home_color_type_id: false,
    away_color_type_id: false
  });

  useEffect(() => {
    (async () => {
      const resSportsHall = await listSportsHall();
      const resColorTypes = await listColorTypes();
      setSportsHall(resSportsHall);
      setColorTypes(resColorTypes);
    })();
  }, []);

  const handelInput = e => {
    const { name, value } = e.target;
    setClub({ ...club, [name]: value });
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!validateForm(event)) return;

    const form = event.currentTarget;
    const _data = {
      name: form.name.value,
      short_name: form.short_name.value,
      place: form.place.value,
      federation_entities_id: form.federation_entities_id.value,
      sports_hall_id: form.sports_hall_id.value,
      home_color_type_id: form.home_color_type_id.value,
      away_color_type_id: form.away_color_type_id.value,
      image: form.image.files[0]
    };

    await edit(_data, club.document_guid);
    onSave();
    onClose();
  };

  const validateForm = event => {
    const form = event.currentTarget;
    const newErrors = {
      name: !form.name.value.trim(),
      short_name: !form.short_name.value.trim(),
      place: !form.place.value.trim(),
      federation_entities_id: !form.federation_entities_id.value,
      sports_hall_id: !form.sports_hall_id.value,
      home_color_type_id: !form.home_color_type_id.value,
      away_color_type_id: !form.away_color_type_id.value,
    };
    setErrors(newErrors);

    if (Object.values(newErrors).some(error => error)) {
      event.stopPropagation();
      return false;
    }
    return true;
  };

  return (
    <Card>
      <Card.Body className="bg-body-tertiary">
        <Form
          method="PUT"
          encType="multipart/form-data"
          noValidate
          onSubmit={handleSubmit}
        >
          <Row className="mb-3">
            <Form.Group as={Col} md="12" controlId="name">
              <Form.Label>Naziv kluba</Form.Label>
              <Form.Control
                required
                type="text"
                name="name"
                value={club.name || ''}
                onChange={handelInput}
                isInvalid={errors.name}
              />
              <Form.Control.Feedback type="invalid">
                Molimo unesite naziv kluba.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="short_name">
              <Form.Label>Skraćeni naziv</Form.Label>
              <Form.Control
                required
                type="text"
                name="short_name"
                value={club.short_name || ''}
                onChange={handelInput}
                isInvalid={errors.short_name}
              />
              <Form.Control.Feedback type="invalid">
                Molimo unesite skraćeni naziv.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group controlId="image">
              <Form.Label>Izaberi logo</Form.Label>
              <Form.Control type="file" name="image" />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="place">
              <Form.Label>Mjesto</Form.Label>
              <Form.Control
                required
                type="text"
                name="place"
                value={club.place || ''}
                onChange={handelInput}
                isInvalid={errors.place}
              />
              <Form.Control.Feedback type="invalid">
                Molimo unesite mjesto.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="8" controlId="federation_entities_id">
              <Form.Label>Savez</Form.Label>
              <Form.Select
                  name="federation_entities_id"
                  value={club.federation_entities_id || ''}
                  onChange={handelInput}
                  required
                  isInvalid={errors.federation_entities_id}
              >
                <option value="">-- Izaberi --</option>
                <option value="1721">Crna Gora</option>
              </Form.Select>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="12" controlId="sports_hall_id">
              <Form.Label>Hala</Form.Label>
              <Form.Select
                name="sports_hall_id"
                value={club.sports_hall_id || ''}
                onChange={handelInput}
                required
                isInvalid={errors.sports_hall_id}
              >
                <option value="">Izaberi</option>
                {sportsHall.map(p => (
                  <option key={p.sports_hall_id} value={p.sports_hall_id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="home_color_type_id">
              <Form.Label className="d-flex align-items-center gap-2">
                Dres kao domaćin
                <span
                  style={{
                    display: 'inline-block',
                    width: '14px',
                    height: '14px',
                    borderRadius: '3px',
                    border: '1px solid #ced4da',
                    backgroundColor: getColorValue(getColorTypeById(club.home_color_type_id)?.background_color) || 'transparent'
                  }}
                />
              </Form.Label>
              <Form.Select
                name="home_color_type_id"
                value={club.home_color_type_id || ''}
                onChange={handelInput}
                required
                isInvalid={errors.home_color_type_id}
              >
                <option value="">Izaberi</option>
                {colorTypes.map(p => (
                  <option key={p.color_types_id} value={p.color_types_id}>
                    {p.background_color}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} md="6" controlId="away_color_type_id">
              <Form.Label className="d-flex align-items-center gap-2">
                Dres kao gost
                <span
                  style={{
                    display: 'inline-block',
                    width: '14px',
                    height: '14px',
                    borderRadius: '3px',
                    border: '1px solid #ced4da',
                    backgroundColor: getColorValue(getColorTypeById(club.away_color_type_id)?.background_color) || 'transparent'
                  }}
                />
              </Form.Label>
              <Form.Select
                name="away_color_type_id"
                value={club.away_color_type_id || ''}
                onChange={handelInput}
                required
                isInvalid={errors.away_color_type_id}
              >
                <option value="">Izaberi</option>
                {colorTypes.map(p => (
                  <option key={p.color_types_id} value={p.color_types_id}>
                    {p.background_color}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>

          <Button type="submit">Sačuvaj</Button>
        </Form>
      </Card.Body>
    </Card>
  );
}
